import { useTranslation } from 'react-i18next'
import useDocumentTitle from '../../lib/useDocumentTitle'
import { PageHeader } from '@ant-design/pro-layout'
import { PersonalDataSettings } from '../../components/MyAccount/PersonalDataSettings'

export function PersonalDataPage() {
  const { t } = useTranslation()
  useDocumentTitle(t('frontend:myAccount.personalDataPage.documentTitle'))

  return (
    <>
      <PageHeader
        style={{
          textOverflow: 'ellipsis',
          overflow: 'hidden',
          whiteSpace: 'nowrap',
        }}
        breadcrumb={{
          items: [
            {
              key: 'my-account',
              title: t('frontend:myAccount.breadcrumb.myAccount'),
            },
            {
              key: 'personal-data',
              title: t('frontend:myAccount.breadcrumb.personalData'),
            },
          ],
        }}
        title={t('frontend:myAccount.personalDataPage.title')}
      />
      <PersonalDataSettings />
    </>
  )
}
